import { useQuery } from '@tanstack/react-query'

import { getTfaSmsRecoveryCode } from '@src/api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchTfaSmsRecoveryCode = (clicked: boolean) => {
  const { axiosInstance } = useAxios({ apiType: 'IAM' })
  axiosInstance.defaults.responseType = 'blob'
  const { data, isError, isLoading } = useQuery({
    enabled: clicked,
    queryFn: () => getTfaSmsRecoveryCode(axiosInstance),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_TFA_SMS_RECOVERY_CODE],
  })

  return { data, isError, isLoading }
}
